<template>
  <div class="customer">
    <div class="top-container">
      <div
        class="month-active"
      >
        <div class="month-active-title-container">
          <div class="title">30日活跃用户趋势图</div>
        </div>
        <div id="monthActive" :style="{ width: '100%', height: '320px' }"></div>
      </div>

      <div
        class="month-new"
      >
        <div class="month-new-title-container">
          <div class="title">30日新用户趋势图</div>
        </div>
        <div id="monthNew" :style="{ width: '100%', height: '320px' }"></div>
      </div>
    </div>
    
    <div class="content">
      <div
        class="contribution"
      >
        <div class="contribution-title-container">
          <div class="title">
            <span>当月客户贡献排名</span>
            <div class="legend-container">
              <div class="legend-item">
                <img class="legend-img" src="../../../../assets/home/legend-blue.png">
                <span>累计金额</span>
              </div>
              <div class="legend-item">
                <img class="legend-img" src="../../../../assets/home/legend-origin.png">
                <span>下单次数</span>
              </div>
              <div class="legend-item">
                <img class="legend-img" src="../../../../assets/home/legend-green.png">
                <span>登录次数</span>
              </div>
            </div>
            <div></div>
          </div>
        </div>
        <div id="contribution" :style="{ width: '100%', height: '320px' }"></div>
      </div>
    </div>

    <div class="footer-content">
      <div class="title">客户贡献排名详情</div>
      <div class="search">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="客户名称：" prop="customerName">
            <el-input
              class="white"
              v-model="form.customerName"
              clearable
              placeholder="请输入客户名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="日期：" prop="date">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <div class="btn">
            <el-tooltip class="item" effect="dark" content="最多只可选择30天" placement="top">
              <img class="question-mark" src="../../../../assets/home/question-mark.png">
            </el-tooltip>
            <el-button class="btn-blue" @click="search">筛选</el-button>
          </div>
        </el-form>
      </div>
      <div class="table" ref="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="loading"
          @sort-change="sortChange"
        >
          <el-table-column
            v-for="(item, index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :min-width="item.width"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <div class="table_pagination">
          <pagination-tpl
            @queryChange="updatePage"
            :pageSize="pageSize"
            :currentPage="page"
            :total="total"
          ></pagination-tpl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DBReport from "models/db/report.js";
import PaginationTpl from "base/PaginationTpl";
import { formatTimeToDate } from "common/js/util.js";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      monthActiveEcharts: null,
      monthNewEcharts: null,
      contributionEcharts: null,
      tableData: [],
      tableTitle: [
        {prop: 'customerName', label: '客户名称', width: '', sortable: false},
        {prop: 'cumulativeAmount', label: '累计金额', width: '', sortable: true},
        {prop: 'overbookingNums', label: '下单次数', width: '', sortable: true},
        {prop: 'loginTimes', label: '登录次数', width: '', sortable: true}
      ],
      form: {
        customerName: '',
        date: this.timeDefault(),
        sortType: 2
      },
      selectDate: '',
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      loading: true,
      total: 0, // 数据总数量
      page: 1,
      pageSize: 20,
    }
  },

  created() {
    this.initList()
  },

  mounted() {
    this.initMonthActive()
    this.initMonthNew()
    this.initContribution()
    window.addEventListener("resize", () => {
      this.initResize()
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.initResize()
    })
  },

  methods: {
    timeDefault() {
      let date = new Date();
      const yesterday = formatTimeToDate(date.getTime() - 86400000)
      const firstDate = formatTimeToDate(date.getTime() - 86400000*7)
      let arr = [firstDate, yesterday]
      return arr;
    },

    initMonthActive() {
      DBReport.getMonthActiveUsre().then(res => {
        if (res.success) {
          let dateArr = []
          let monthSalesYArr = []
          res.result.map(i => {
            let date = i.date.slice(-5)
            dateArr.push(date)
            monthSalesYArr.push(i.loginCount)
          })
          this.initMonthActiveEchart(dateArr, monthSalesYArr)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    initMonthNew() {
      DBReport.getMonthNewUsre().then(res => {
        if (res.success) {
          let dateArr = []
          let salesOverviewYArr = []
          res.result.map(i => {
            let date = i.date.slice(-5)
            dateArr.push(date)
            salesOverviewYArr.push(i.registerCount)
          })
          this.initMonthNewEchart(dateArr, salesOverviewYArr)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    initContribution() {
      DBReport.getMonthCustomersRanking().then(res => {
        if (res.success) {
          let nameArr = []
          let cumulativeAmountArr = []
          let overbookingNumsArr = []
          let loginTimesArr = []
          res.result.map(i => {
            nameArr.push(i.xbName)
            cumulativeAmountArr.push(i.saleAmount)
            overbookingNumsArr.push(i.orderCount)
            loginTimesArr.push(i.loginCount)
          })
          this.initContributionEchart(nameArr, cumulativeAmountArr, overbookingNumsArr, loginTimesArr)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 30日活跃用户趋势图 */
    initMonthActiveEchart(dateArr, monthSalesYArr) {
      this.monthActiveEcharts = this.$echarts.init(document.getElementById("monthActive"));
      let colorList = ["#03E38A", "#9BFFD7"];
      this.monthActiveEcharts.setOption({
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: 'left',
          },
          formatter: "日期：" + "{b0}" + "<br/>" + "活跃用户数量：" + "{c0}",
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "2%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dateArr,
          axisLabel: {
            interval: 3
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          name: "单位：个",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        series: [
          {
            type: "line",
            data: monthSalesYArr,
            color: colorList[0],
            areaStyle: {},
            symbolSize:8,
            symbol:"circle",
            itemStyle: {
              borderWidth:2,
              borderColor:'white',  // 拐点边框颜色,
              color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(155,255,215,0)",
                },
                {
                  offset: 1,
                  color: "rgba(3,227,138,0.9000)",
                },
              ]),
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: colorList[0], // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: colorList[0], // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: colorList[0], // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      });
    },
    
    /* 30日新用户趋势图 */
    initMonthNewEchart(dateArr, salesOverviewYArr) {
      this.monthNewEcharts = this.$echarts.init(document.getElementById("monthNew"));
      let colorList = ["#FFAC41"];
      this.monthNewEcharts.setOption({
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: 'left',
          },
          formatter: "日期：" + "{b0}" + "<br/>" + "新用户数量：" + "{c0}",
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "2%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dateArr,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          name: "单位：个",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        series: [
          {
            type: "line",
            data: salesOverviewYArr,
            color: colorList[0],
            areaStyle: {},
            symbolSize:8,
            symbol:"circle",
            itemStyle: {
              borderWidth:2,
              borderColor:'white',  // 拐点边框颜色,
              color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(255,255,255,0)",
                },
                {
                  offset: 1,
                  color: "rgba(255,172,65,0.9000)",
                },
              ]),
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: colorList[0], // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: colorList[0], // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: colorList[0], // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      });
    },
    
    /* 客户贡献排名 */
    initContributionEchart(nameArr, cumulativeAmountArr, overbookingNumsArr, loginTimesArr) {
      this.contributionEcharts = this.$echarts.init(document.getElementById("contribution"));
      this.contributionEcharts.setOption({
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: 'left',
          },
          formatter: "客户名称：" + "{b0}" + "<br/>" + "累计金额：" + "{c0}"+ "<br/>"+ "下单次数：" + "{c4}"+ "<br/>"+ "登录次数：" + "{c6}",
        },
        grid: {
          top: "10%",
          left: "2%",
          right: "2%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: nameArr,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            interval: 0,
            formatter: function (params) {
              let newParamsName = ""; // 最终拼接成的字符串
              let paramsNameNumber = params.length; // 实际标签的个数
              let provideNumber = 5; // 每行能显示的字的个数
              // let rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              let rowNumber = 3; // 换行的话，需要显示几行，向上取整
              /**
              * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
              */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (let p = 0; p < rowNumber; p++) {
                  let tempStr = ""; // 表示每一次截取的字符串
                  let start = p * provideNumber; // 开始截取的位置
                  let end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    // tempStr = params.substring(start, paramsNameNumber);
                    
                    if (paramsNameNumber > (provideNumber*rowNumber)) {
                      tempStr = params.substring(start, end) + "...";
                    } else {
                      tempStr = params.substring(start, end);
                    }
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
        },
        yAxis: [
          {
            type: "value",
            name: "单位：元",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              formatter: (value) => {
                let texts = [];
                if (value == 0) {
                  texts.push(value);
                } else {
                  let num = value / 1000;
                  let str = num + "k";
                  texts.push(str);
                }
                return texts;
              }
            },
          },
          {
            type: 'value',
            name: '单位：次',
            position: 'right',
            alignTicks: true,
            offset: 4,
            axisLine: {
              show: false,
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            // 左侧柱形
            type: "bar",
            name: '累计金额',
            data: cumulativeAmountArr,
            barGap: 0,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: '#92B3FF'
            }
          },
          {
            // 右侧柱形
            type: "bar",
            name: '累计金额',
            data: cumulativeAmountArr,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: "#749EFF",
            }
          },
          {
            // 顶部菱形
            data: cumulativeAmountArr,
            type: "pictorialBar",
            name: '累计金额',
            barMaxWidth: "20",
            symbolPosition: "end",
            symbol: "diamond",
            symbolOffset: [-20, "-50%"],
            symbolSize: [20, 10],
            zlevel: 3,
            itemStyle: {
              color: '#ABC4FF',
            }
          },
          {
            // 左侧柱形
            type: "bar",
            yAxisIndex: 1,
            name: '下单次数',
            data: overbookingNumsArr,
            barGap: 0,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: '#FFDAB1'
            }
          },
          {
            // 右侧柱形
            type: "bar",
            yAxisIndex: 1,
            name: '下单次数',
            data: overbookingNumsArr,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: "#FFBC73",
            }
          },
          {
            // 顶部菱形
            data: overbookingNumsArr,
            type: "pictorialBar",
            yAxisIndex: 1,
            name: '下单次数',
            barMaxWidth: "20",
            symbolPosition: "end",
            symbol: "diamond",
            symbolOffset: [0, "-50%"],
            symbolSize: [20, 10],
            zlevel: 3,
            itemStyle: {
              color: '#FFE9D1',
            }
          },
          {
            // 左侧柱形
            type: "bar",
            name: '登录次数',
            yAxisIndex: 1,
            data: loginTimesArr,
            barGap: 0,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: '#7BECBF'
            }
          },
          {
            // 右侧柱形
            type: "bar",
            yAxisIndex: 1,
            name: '登录次数',
            data: loginTimesArr,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: "#32DB98",
            }
          },
          {
            // 顶部菱形
            data: loginTimesArr,
            name: '登录次数',
            yAxisIndex: 1,
            type: "pictorialBar",
            barMaxWidth: "20",
            symbolPosition: "end",
            symbol: "diamond",
            symbolOffset: [20, "-50%"],
            symbolSize: [20, 10],
            zlevel: 3,
            itemStyle: {
              color: '#80FCCB',
            }
          },
        ],
      });
    },

    initResize() {
      this.monthActiveEcharts.resize();
      this.monthNewEcharts.resize();
      this.contributionEcharts.resize();
    },

    initList() {
      let xbName = this.form.customerName
      let beginDate = this.form.date ? this.form.date[0]:''
      let endDate = this.form.date ? this.form.date[1]:''
      let pageNo = this.page
      let sortType = this.form.sortType
      let data = {
        xbName,
        beginDate,
        endDate,
        pageNo,
        sortType
      }
      DBReport.getCustomersRankingDetails(data).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          this.pageSize = res.result.pageSize;
          let arr = [];
          res.result.items.map(i => {
            let obj = {}
            obj.customerName = i.xbName
            obj.cumulativeAmount = i.saleAmount
            obj.overbookingNums = i.orderCount
            obj.loginTimes = i.loginCount
            arr.push(obj)
          })
          this.tableData = arr
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },

    sortChange(column) {
      if (column.order === 'ascending') {
        // 升序
        if (column.prop === 'cumulativeAmount') {
          this.form.sortType = 1
        } else if (column.prop === 'overbookingNums') {
          this.form.sortType = 3
        } else if (column.prop === 'loginTimes') {
          this.form.sortType = 5
        }
      } else {
        // 降序
        if (column.prop === 'cumulativeAmount') {
          this.form.sortType = 2
        } else if (column.prop === 'overbookingNums') {
          this.form.sortType = 4
        } else if (column.prop === 'loginTimes') {
          this.form.sortType = 6
        }
      }
      this.search()
    },
    
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.initList();
    },

    search() {
      this.page = 1;
      this.initList();
    }
  }
}
</script>

<style lang='scss'>
.customer {
  flex: 1;
  padding: 0px 16px 16px;
  overflow-y: auto;
  box-sizing: border-box;
  .top-container {
    display: flex;
    justify-content: flex-start;
    .month-active,
    .month-new {
      width: 50%;
      padding: 0px 19px;
      border-radius: 4px;
      background: white;
      box-sizing: border-box;
      &-title-container {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: #666666;
        }
      }
    }
    .month-active {
      margin-right: 16px;
    }
  }
  .content {
    .contribution {
      margin-top: 16px;
      padding: 0px 19px;
      border-radius: 4px;
      background: white;
      box-sizing: border-box;
      &-title-container {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          width: 100%;
          font-size: 18px;
          font-weight: 500;
          color: #666666;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .legend-container {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            .legend-item {
              margin-right: 30px;
              .legend-img {
                width: 18px;
                height: 13px;
                margin-right: 9px;
              }
            }
            .legend-item:last-child {
              margin-right: 0px;
            }
          }
        }
      }
    }
  }
  .footer-content {
    background: white;
    padding: 18px 20px;
    margin-top: 16px;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #666666;
      margin-bottom: 16px;
    }
    .search {
      height: 66px;
      background: #F5F7FA;
      border-radius: 4px;
      margin-bottom: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .el-form {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-form-item {
          margin-bottom: 0px;
        }
        .btn {
          .question-mark {
            width: 14px;
            height: 14px;
            margin-left: 8px;
            margin-right: 21px;
          }
        }
      }
    }
    .table {
      .table_pagination {
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
    }
  }
}
</style>
